import { Box, styled } from '@mui/material'
import i18n from 'i18n'

export const TextButtonContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))

export const TabMenuContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: '200px',
  borderRadius: '20px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  padding: '8px',
  margin: '8px',
  backgroundColor: 'white'
}))

export const TabMenuItem = styled(Box)<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 16px',
    cursor: 'pointer',
    borderRadius: '12px',
    backgroundColor: selected ? '#F5F5F5' : 'transparent',
    color: 'black',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: selected ? '#F5F5F5' : '#FAFAFA'
    },
    '& svg': {
      width: '20px',
      height: '20px',
      minWidth: '20px',
      minHeight: '20px',
      color: selected ? 'black' : theme.palette.text.secondary
    }
  })
)

export const TabMenuLabel = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: 'inherit',
  whiteSpace: 'nowrap'
}))

export const DialogLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  minHeight: '500px'
}))

export const TabContentContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: '40px 16px 16px 16px',

  width: '460px',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: '8px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
    marginRight: '8px'
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '8px',
    border: '1px solid white',
    backgroundClip: 'padding-box'
  }
}))
